
/**
 * `SimpleTeaser` - Simple Teaser Component.
 * This is the wrapper component- This component uses workbench wb-content-slider.
 * {@link https://wb2.oneweb.mercedes-benz.com/developer/web-components/content-slider}
 * This component accepts a datajson as attribute to change the theme between light and dark {theme: 'light' | 'dark'}
 * As slot, SimpleTeaser uses SimpleTeaserItem (owc-simple-teaser-item) which will be the slide for the wb-content-slider.
 * SimpleTeaserItem should always have the classes:
 * - wb-grid-col-mq6-3 wb-grid-col-mq4-4 wb-grid-col-mq3-6 wb-grid-col-mq1-12 owc-wb-grid-col-mq-2-3-midpoint
 * - owc-simple-teaser-item
 * - wb-content-slider__item
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import { SimpleTeaserComponent } from '@owc-packages/SimpleTeaser/src/SimpleTeaser';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import Personalisation from '@owc-utils/Mixins/Personalisation';
import {
  OWCPersonalisationState,
  OWC_PERSONALISATION_CONNECTION,
} from '@owc-utils/SeamlessStore/connections';
import { initializeStore } from '@seamless/store';
import { filterVisibleSlots } from '@owc-utils/Slot/SlotAttributes';
import { getLocalFootnotes, setModuleId } from '@owc-utils/Footnotes/FootnotesHelper';
import { getFootnotesIfAvailable } from '../../_utils/Footnotes/FootnotesUtils';
//AEATEAM-724: the following code should be removed when the globalelem footnote solution is to go live:
// - <Footnotes> component and respective v-if v-else
// - Dynamic import of Footnotes.vue
// - isProduction computed property and all of its conditions

export default (ComponentInitializeDispatcher as SimpleTeaserComponent).extend({
  name: 'owc-simple-teaser',
  components: {
    SlotContainer,
    ValidationBoxWrapper,
    Footnotes: () => import('@owc-packages/Footnotes/src/Footnotes.vue'),
  },
  mixins: [OwcDataComponent, Personalisation],
  mounted() {
    this.namedSlots = filterVisibleSlots(this.$slots);
    const store = initializeStore();

    this.subscription = store.subscribe(OWC_PERSONALISATION_CONNECTION, (state: OWCPersonalisationState) =>
      this.handlePersonalisationItems(state),
    );
    this.shouldShowMedia = true;
  },
  beforeDestroy() {
    this.subscription?.unsubscribe();
  },
  data() {
    return {
      shouldShowMedia: false,
      namedSlots: [],
    };
  },
  computed: {
    isDarkMode: function() {
      return Boolean(this.personaliseableData.darkMode);
    },
    theme: function() {
      return this.isDarkMode ? 'dark' : 'light';
    },
    visibleItems() {
      return this.namedSlots.filter(el => el.isVisible).map(el => el.name);
    },
    footnotes() {
      return this.isProduction
        ? getFootnotesIfAvailable(this.personaliseableData)
        : getLocalFootnotes(this.personaliseableData);
    },
    moduleId() {
      return this.isProduction ? '' : setModuleId(this);
    },
    isProduction() {
      return window.owcfe.isProduction;
    },
  },
  methods: {
    handlePersonalisationItems(state: OWCPersonalisationState): void {
      const personalisationVisibleItems =
        state.find(item => item.componentId === this.componentId)?.itemsToShow ?? [];
      this.updateVisibleItems(personalisationVisibleItems);
    },
    updateVisibleItems(componentIds: Array<string>): void {
      componentIds.forEach(idAdded => {
        this.namedSlots.forEach(slot => {
          if (slot.name === idAdded) {
            slot.isVisible = true;
            (this.$refs.wbSlider as HTMLWbSliderElement).update();
          }
        });
      });
    },
  },
});
